document.querySelectorAll(".upsell-item").forEach((card) => {
  const img = card.querySelector(".upsell-img");
  const select = card.querySelector(".upsell-select");
  const price = card.querySelector(".upsell-price");
  const btn = card.querySelector(".upsell-add");

  let variantId = btn.dataset.variant;

  if (select) {
    select.addEventListener("change", (e) => {
      const opt = e.target.selectedOptions[0];

      img.src = opt.dataset.image;
      price.innerHTML = opt.dataset.price;

      variantId = opt.dataset.variantId;
    });
  }

  btn.addEventListener("click", () => {

    const app = Alpine.$data(document.querySelector('[x-data]'));

    app.addCartItem(variantId, 0, 1, true);

    btn.innerHTML = "✓ Added";
    setTimeout(() => (btn.innerHTML = "Add to cart"), 1500);
  });
});